module.exports = "/static-assets/_next/static/images/post-0832088ba29a5ad8fa4bffb1a63807a7.jpg";